var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vf-valsum",class:[
    { 'vf-valsum-selected' : _vm.selected }
],on:{"click":_vm.handleClick}},_vm._l((_vm.items),function(item,i){return _c('div',{key:'ve' + i},[_c('div',{domProps:{"innerHTML":_vm._s(item.display)}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }